import Bugsnag from "@bugsnag/js";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { referrerService } from "@/modules/contacts/features/referrer/store/services/referrer-service";
import { REFERRER_SERVICE_TAG } from "@/modules/contacts/features/referrer/utils/referrer-service-tags";
import { REFERRER_ANALYTIC_EVENTS } from "@/modules/contacts/features/referrer/utils/referrer-analytic-events";
import { CONTACT_SERVICE_TAG } from "@/modules/contacts/utils/contact-service-tags";
import { contactService } from "@/modules/contacts/store/services/contact-service";

const updateReferrer = referrerService.injectEndpoints({
  endpoints: builder => ({
    updateReferrer: builder.mutation({
      query: ({ referrerId: id, ...body }) => ({
        url: `referrers/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: REFERRER_SERVICE_TAG, id }],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          sendAnalytics(REFERRER_ANALYTIC_EVENTS.REFERRER_UPDATED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Referrer has been updated!",
                options: {
                  variant: NOTIFICATION_VARIANTS.SUCCESS,
                },
              },
            }),
          );
          dispatch(contactService.util.invalidateTags([CONTACT_SERVICE_TAG]));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateReferrerMutation } = updateReferrer;

